import { all, takeEvery, call, put } from "redux-saga/effects";
import { create } from "services/apis/jwt";
import actions from "./actions";

function* loading(isLoading = false, error = false) {
  yield put({
    type: actions.SET_STATE,
    payload: {
      loading: isLoading,
      error,
    },
  });
}

export function* CREATE({ payload }) {
  yield loading(true);

  const response = yield call(create, payload);
  if (response) {
    yield put({
      type: actions.SET_STATE,
      payload: {
        accessToken: response,
        loading: false,
      },
    });
  }

  if (!response) {
    yield loading(false, true);
  }
}

export default function* rootSaga() {
  yield all([takeEvery(actions.CREATE, CREATE)]);
}
